import cronJobPayloadSchema from 'root/src/shared/descriptions/endpoints/schemas/requestSchemas/cronJobPayloadSchema';
import { snapshotEndpointIds } from 'root/src/shared/snapshots/snapshot.constants';
export const saveTableSnapshotsEndpoint = {
    [snapshotEndpointIds.SAVE_TABLE_SNAPSHOTS]: {
        payloadSchema: cronJobPayloadSchema,
        isCron: true,
    },
};
